import actions from './actions'
import saga from '../../GeneralListFunctions/sagaFactory'

export default () =>
  saga(
    actions,
    () => 'v1/newsletter/subscription-status/user',
    (state) => state.mailManageRegistrations
  )
